import React from 'react';
import { FormCreateApp } from 'view/common/fields/proforma/form-create-app';
import RequestCreateForm from '../hocs';
export type { FormErrors, FormInput } from '../types';

const RequestCreateFormWithProforma = (props: React.ComponentProps<typeof RequestCreateForm>) => {
    return <RequestCreateForm {...props} proformaField={FormCreateApp} />;
};

export default RequestCreateFormWithProforma;
